import type { ApiResponse } from "~/types";
import type { CartPromotionItem } from "~/types/ConfirmOrder";
import type { OmsCartItem } from "~/types/OmsCartItem";
import type { CartProduct } from "~/types/ProductDetails";
import type { NitroFetchRequest, $Fetch } from 'nitropack'

export const cartRepository = () => ({

  async addCartItem(cartItem: OmsCartItem) {
    return await useAPIFetch<ApiResponse<number>>('/cart/add', {
      method: 'POST',
      body: JSON.stringify(cartItem),
      headers: { 'Content-Type': 'application/json' },
    });
  },

  async fetchCartList() {
    return await useAPI<ApiResponse<OmsCartItem[]>>('/cart/list');
  },

  async fetchCartListPromotions(ids?: number[]) {
    return await useAPIFetch<ApiResponse<CartPromotionItem[]>>('/cart/list/promotion', {
      params: { ids },
    });
  },

  async getCartProduct(ids: number[]) {
    return await useAPI<ApiResponse<CartProduct[]>>('/cart/getProducts', {
      method: 'POST',
      params: { ids },
    });
  },

  async saveLater(id: number) {
    return await useAPIFetch<ApiResponse<number>>('/cart/saveLater', {
      method: 'GET',
      params: { id },
    });
  },

  async moveToCart(id: number) {
    return await useAPIFetch<ApiResponse<number>>('/cart/moveToCart', {
      method: 'GET',
      params: { id },
    });
  },

  async deleteCartItem(ids: number[]) {
    return await useAPIFetch<ApiResponse<number>>('/cart/delete', {
      method: 'POST',
      params: { ids },
    });
  },

  async updateQuantity(id: number, quantity: number) {
    return await useAPIFetch<ApiResponse<number>>('/cart/update/quantity', {
      method: 'GET',
      params: { id, quantity },
    });
  },

  async clearCartList() {
    return await useAPIFetch<ApiResponse<number>>('/cart/clear', {
      method: 'POST',
    });
  },
});
